import { Component, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ModalDirective, ToastService } from 'ng-uikit-pro-standard';
import { SecurityService } from 'src/app/shared/services/security.service';
import { ModalSeleccionarProveedorComponent } from 'src/app/views/shared/modal-seleccionar-proveedor/modal-seleccionar-proveedor.component';
import { RutService } from 'src/app/shared/services/rut.service';
import { ConsoleService } from 'src/app/shared/services/console.service';
import { FormValidatorsService } from 'src/app/shared/services/form-validators.service';
import { TipoDTEService } from 'src/app/services/tipo-dte.service';
import { debounceTime, filter } from 'rxjs/operators';
import { DatesService } from 'src/app/shared/services/dates.service';
import { ModalSeleccionDocumentoComponent } from '../modal-seleccion-documento/modal-seleccion-documento.component';
import { MotivoDevolucionService } from '../../../../services/motivo-devolucion.service';
import { MessageRendererService } from '../../../../services/message-renderer.service';
import { BodegaService } from '../../../../services/bodega.service';
import { DocumentoRecepcionadoService } from '../../../../services/documento-recepcionado.service';

@Component({
  selector: 'app-modal-anulacion-doc',
  templateUrl: './modal-anulacion-doc.component.html',
  styleUrls: ['./modal-anulacion-doc.component.scss'],
  providers: [SecurityService],
})
export class ModalAnulacionDocComponent implements OnInit {
  @ViewChild('anulacionDoc', { static: true })
  anulacionDocModal: ModalDirective;


  /** MODAL SELECCIONAR DOCUMENTO **/
  @ViewChild(ModalSeleccionDocumentoComponent, { static: true }) modalSeleccionarDocumento: ModalSeleccionDocumentoComponent

  /** DATA PARA OBTENER PROVEEDOR */
  @ViewChild(ModalSeleccionarProveedorComponent, { static: true }) modalSeleccionarProveedor: ModalSeleccionarProveedorComponent;
  @Output() onProveedorChange: EventEmitter<any> = new EventEmitter<any>();
  @Output() onExecuteBuscar: EventEmitter<any> = new EventEmitter<any>()

  // Utils
  private log: any;

  // Form
  formHeader: FormGroup;
  formMotivoGeneral: FormGroup;

  optionsTipoFact: Array<any> = [];
  optionsMonth: Array<any> = [];
  optionsYear: Array<any> = [];
  optionsBodega: Array<any> = [];

  // Data & tmp
  public rutEmpresa: number;
  public sucursalCodigo: number;
  public rut_usuario: number;

  /** DATA PARA OBTENER PROVEEDOR */
  proveedorSeleccionado: any = null;
  headerData: any = {};
  seleccionaRutProveedor: any;

  /* DATA PARA N° DOC */
  dataCabecera: any = null
  dataDetalle: any = null
  optionsMotivoGeneral: Array<any> = [];
  //TOTAL CABECERA
  SubTotal: number = 0;
  DescGbl: number = 0;
  RecargoGbl: number = 0;
  MontoAf: number = 0; //A
  MontoEx: number = 0; //B
  MontoIva: number = 0; //C
  IvaRec: number = 0;
  IvaNoRec: number = 0;
  IvaActF: number = 0;
  IvaRet: number = 0;
  IvaComn: number = 0;
  TotalBruto: number = 0;
  montoTotal: number = 0;
  EnableButton: boolean;
  Existefolio: any;
  listaDetalleVacia: Array<any> = [];

  constructor(
    private rutService: RutService,
    private accesolocalstorage: SecurityService,
    private fb: FormBuilder,
    private clog: ConsoleService,
    private formValidatorsService: FormValidatorsService,
    private tipodteService: TipoDTEService,
    private datesService: DatesService,
    private toastService: ToastService,
    private motivodevolucionService: MotivoDevolucionService,
    private messageRendererService: MessageRendererService,
    private bodegaService: BodegaService,
    private documentoRecepcionadoService: DocumentoRecepcionadoService,
    private motivoDevolucionService: MotivoDevolucionService,

  ) {
    this.log = this.clog.log('ANULAR DOCUMENTO');
  }

  ngOnInit() {
    this.rutEmpresa = Number(this.accesolocalstorage.getRutEmpresa());
    this.sucursalCodigo = Number(this.accesolocalstorage.getSucursalCodigo());
    this.rut_usuario = this.accesolocalstorage.getRutUsuario();

    this.loadYears();
    this.loadMonths();
    this.loadBodega();
    this.createForm();
    this.loadTipoFactura();
    this.loadMotivoDevolucionGeneral();
    this.formChangesSubscriptions();
    this.setDefaults();
  }

  /********* FORM *********/
  private createForm() {
    const { initDate, currentDate } = this.datesService.GetStartAndCurrentMonth()

    this.formHeader = this.fb.group({
      rutProveedor: [null, [Validators.required]],
      tipoFact: [''],
      mes: [null, [Validators.required]],
      anho: [null, [Validators.required]],
      nroDoc: [null],
      nFolio: [null, [Validators.required]],
      // MueveInventario: [true],
      tipoBodega: ['', [Validators.required]],
      FechaDoc: [currentDate],
      FechaVenc: [currentDate],
    });
    this.formMotivoGeneral = this.fb.group({
      motivo: [null, [Validators.required]]
    });
  }

  formChangesSubscriptions() {
    this.formHeader
      .get('rutProveedor')
      .valueChanges.pipe(filter(Boolean), debounceTime(2500))
      .subscribe((rut: string) => {
        this.modalSeleccionarProveedor.searchByRut(rut);
      });

    this.formHeader.get("nroDoc").valueChanges
      .pipe(filter(Boolean), debounceTime(1000))
      .subscribe((nroDoc: string) => {
        if (!nroDoc)
          return
        this.searchByNroDoc()
      })
  }

  /********* ABRIR MODAL *********/

  show() {
    this.anulacionDocModal.show();
  }

  /****CERRAR MODAL**/
  CloseModal() {
    this.formHeader.reset()
    this.anulacionDocModal.hide();
    this.proveedorSeleccionado = [];
    this.formHeader.get('mes').setValue(this.optionsMonth[0].value);
    this.formHeader.get('anho').setValue(this.optionsYear[0].value);
    this.formHeader.get('nFolio').setValue(null);
    this.formHeader.get('nroDoc').setValue(null);
    this.formValidatorsService.selectFirstOrDefault(this.formHeader.get('tipoFact'), this.optionsTipoFact)
    this.formHeader.get('rutProveedor').setValue(null);
    // this.formHeader.get('MueveInventario').setValue(true);
    this.formValidatorsService.selectFirstOrDefault(this.formHeader.get('tipoBodega'), this.optionsBodega)
  }

  // NOTE: OBTENER FACTURA

  loadTipoFactura() {
    this.tipodteService.GetByTipoDte(1, ({ respuesta }) => {
      const { registros } = respuesta
      this.optionsTipoFact = registros.map(tipo => ({ value: tipo.codigo, label: tipo.nombre, ...tipo }))
      this.setDefaultDoctoReferencia()
    })
    this.formValidatorsService.selectFirstOrDefault(this.formHeader.get('tipoFact'), this.optionsTipoFact)

  }

  private loadMotivoDevolucionGeneral() {
    // Tipos documentos
    this.motivoDevolucionService.GetMotivoDevolucionGeneral(this.rutEmpresa, this.sucursalCodigo, ({ respuesta }) => {
      const { registros } = respuesta
      this.optionsMotivoGeneral = registros.map(tipo => ({ value: tipo.codigo, label: tipo.nombre, ...tipo }))
      console.log("muestrame el motivo ", this.optionsMotivoGeneral);
    })
  }

  get doctoReferencia() {
    if (this.formHeader && this.formHeader.get("tipoFact"))
      return this.formHeader.get("tipoFact").value
    return 0
  }


  setDefaultDoctoReferencia() {
    const facturaOption = this.optionsTipoFact.filter(p => p.codigo === 33);
    if (facturaOption && facturaOption.length > 0)
      this.formHeader.get('tipoFact').setValue(facturaOption[0].codigo);
  }

  loadBodega() {
    const inputParams = {
      rut_empresa: this.rutEmpresa,
      sucursal_codigo: this.sucursalCodigo
    }

    this.bodegaService.ObtenerBodegas(inputParams, ({ respuesta }) => {
      const { registros } = respuesta
      this.optionsBodega = registros.map(bodega =>
      ({
        value: bodega.codigo,
        label: bodega.nombre,
        ...bodega
      }))
      this.formValidatorsService.selectFirstOrDefault(this.formHeader.get('tipoBodega'), this.optionsBodega)
    })
  }



  // NOTE: OBTENER MES Y ANHO
  loadMonths() {
    this.optionsMonth = this.datesService.GetCurrentMonths('desc');
  }

  loadYears() {
    this.optionsYear = this.datesService.GetLastYears();
  }

  setDefaults() {
    if (this.optionsMonth.length > 0) this.formHeader.get('mes').setValue(this.optionsMonth[0].value);
    if (this.optionsYear.length > 0) this.formHeader.get('anho').setValue(this.optionsYear[0].value);
  }

  // NOTE: OBTENER PROVEEDOR ****************************************** /
  openModalSeleccionarProveedor() {
    this.modalSeleccionarProveedor.show();
  }

  onProveedorSeleccionado({ data, origen }) {
    this.proveedorSeleccionado = data;
    this.proveedorSeleccionado.rutFormato = this.rutService.AgregarDV(this.proveedorSeleccionado.rut);
    this.formHeader.get('rutProveedor').setValue(this.proveedorSeleccionado.rutFormato);
    this.seleccionaRutProveedor = this.proveedorSeleccionado.rut;

    this.onProveedorChange.emit(this.headerData.proveedorSeleccionado);
  }

  onProveedorNoEncontrado() {
    this.proveedorSeleccionado = null;

    this.clearProveeData();
  }

  clearProveeData() {
    this.clearContent();
    this.onProveedorChange.emit(null);
  }

  clearContent() {
    this.headerData = {};
    this.formValidatorsService.reset(this.formHeader);
  }
  /********************************************************************/

  //NOTE: MODAL N° DOC

  abrirModalSeleccionDocumento() {
    const proveedorRut = this.formHeader.get('rutProveedor').value
    this.modalSeleccionarDocumento.load(proveedorRut)
  }

  onDocumentoSeleccionado({ data }) {

    this.dataCabecera = this.cleanDataCabecera(data)//.cabecera
    this.dataCabecera.cabecera.additionalInfo = {}
    this.dataCabecera.cabecera.additionalInfo.cliente_proveedor_rut_completo = this.rutService.AgregarDV(this.dataCabecera.cabecera.cliente_proveedor_rut)
    this.formHeader.get('nroDoc').setValue(data.cabecera.folio)
    this.MontoAf = data === null ? 0 : data.cabecera.monto_neto
    this.MontoEx = data === null ? 0 : data.cabecera.monto_exento
    this.DescGbl = data === null ? 0 : data.cabecera.monto_descuento
    this.RecargoGbl = data === null ? 0 : data.cabecera.monto_recargo
    this.MontoIva = data === null ? 0 : data.cabecera.monto_iva
    this.TotalBruto = data === null ? 0 : data.cabecera.monto_total

    const datos = this.dataCabecera.detalleDocumento.map(x => {
      const params = {
        "rut_emisor": x.rut_emisor,
        "folio": x.folio,
        "tipo_dte_codigo": x.tipo_dte_codigo,
        "nro_linea": x.nro_linea,
        "equivalencia_producto_id": x.equivalencia_producto_id,
        "producto_proveedor": x.codigo_producto_proveedor,
        "producto_proveedor_descripcion": x.descripcion_producto_proveedor,
        "formato_codigo": x.formato_proveedor,
        "cantidad_recibida": x.cantidad,
        "precio_unitario": x.precio_producto_proveedor,
        "total_linea": x.monto_total,
        "desc_es_porcentaje": x.es_porcentaje_dscto,
        "rec_es_porcentaje": x.es_porcentaje_recargo,
        "producto_valido": x.producto_valido,
        "producto_codigo": x.producto_codigo,
        "formato_codigo_top": x.formato_codigo
      }

      return params;
    })
    this.dataDetalle = datos
  }

  onNotFoundDocumento() {
    this.dataCabecera = null
  }


  searchByNroDoc() {
    const folio = this.formHeader.get("nroDoc").value
    const tipo_dte_codigo = this.formHeader.get("tipoFact").value ? this.formHeader.get("tipoFact").value : 0
    if (folio) {
      const proveedorRut = this.formHeader.get('rutProveedor').value
      this.modalSeleccionarDocumento.searchByNroDoc(Number(folio), Number(tipo_dte_codigo), proveedorRut) // this.formHeader.get("doctoReferencia").value)
    }
  }

  private cleanDataCabecera(_dataCabecera) {

    delete _dataCabecera.cabecera.cliente_proveedor_rut_string

    delete _dataCabecera.cabecera.__typename

    _dataCabecera.detalleDocumento.map(p => {
      delete p.__typename

      // parche para que tome la validación en el detalle
      if (p.motivo_devolucion_especifico_codigo === 0)
        p.motivo_devolucion_especifico_codigo = null

      if (p.atributos) {
        p.atributos.map(attr => {
          delete attr.__typename
        })
      }
    })
    return _dataCabecera
  }




  SaveAnulacion() {
    if (this.TotalBruto === 0) {
      this.toastService.error('Debe ingresar totales');
      return false;
    }

    this.validardorInput();
    this.formValidatorsService.validateAllFormFields(this.formHeader)
    if (!this.formHeader.valid) {
      this.toastService.warning('Favor complete los datos requeridos');
      return
    }

    this.formValidatorsService.validateAllFormFields(this.formMotivoGeneral)
    if (!this.formMotivoGeneral.valid) {
      this.toastService.warning('Favor ingrese motivo');
      return
    }

    console.log("this.dataCabecera", this.formHeader.valid);
    const inputParams: any = {
      entidadReferencia: {
        rut_emisor: this.dataCabecera === null ? 0 : this.dataCabecera.cabecera.rut_emisor,
        tipo_dte_codigo: this.dataCabecera === null ? 0 : this.dataCabecera.cabecera.tipo_dte_codigo,
        folio: this.dataCabecera === null ? 0 : this.dataCabecera.cabecera.folio
      },
      entidad: {
        tipo_ncnd_codigo: 3,
        rut_receptor: this.rutEmpresa,
        sucursal_codigo: this.sucursalCodigo,
        mes: this.formHeader.get('mes').value,
        anno: this.formHeader.get('anho').value,
        rut_emisor: this.rutService.QuitarDV(this.formHeader.get('rutProveedor').value),
        tipo_dte_codigo: 61,
        folio: this.formHeader.get('nFolio').value,
        rut_usuario_recepcion: this.rut_usuario, //rut persona registrada
        fecha_vencimiento: this.formHeader.get('FechaVenc').value,
        condicion_pago_codigo: 0,
        glosa_nominal: "",
        es_entrega_gratuita: this.dataCabecera === null ? false : this.dataCabecera.cabecera.es_entrega_gratuita,
        monto_detalle_bruto: false,
        mueve_cta_cte: true,
        mueve_inv: false,
        bodega_codigo: this.formHeader.get('tipoBodega').value, // crear campo
        facto_iva_uso_comun: 0,
        monto_subtotal: this.dataCabecera === null ? this.SubTotal : this.dataCabecera.cabecera.monto_subtotal,
        monto_descuento: this.dataCabecera === null ? this.DescGbl : this.dataCabecera.cabecera.monto_descuento,
        monto_recargo: this.dataCabecera === null ? this.RecargoGbl : this.dataCabecera.cabecera.monto_recargo,
        monto_afecto: this.dataCabecera === null ? this.MontoAf : this.dataCabecera.cabecera.monto_neto,
        monto_exento: this.dataCabecera === null ? this.MontoEx : this.dataCabecera.cabecera.monto_exento,
        monto_iva: this.dataCabecera === null ? this.MontoIva : this.dataCabecera.cabecera.monto_iva,
        monto_total: this.dataCabecera === null ? this.TotalBruto : this.dataCabecera.cabecera.monto_total,
        motivo_devolucion_codigo: this.formMotivoGeneral.get('motivo').value,
        listaDetalle: this.dataCabecera === null ? this.listaDetalleVacia : this.cleanDetalledocumento(this.dataDetalle)
      }
    }

    this.log('inputParams', JSON.stringify(inputParams))


    this.documentoRecepcionadoService.guardarNotaCreditoRecepcionado(inputParams, ({ mensajes, respuesta }) => {
      const ok = respuesta !== null
      if (!ok) {
        this.messageRendererService.showErrors(mensajes)
        return
      }

      this.toastService.success('Operación realizada con éxito')
      this.CloseModal();
      this.BuscarItems();
    })

  }

  private cleanDetalledocumento(detalleDocumento, cleanCheck: Boolean = true) {
    // let _detalledocumento = [...detalleDocumento]
    let _detalledocumento = [];
    detalleDocumento.forEach(val => _detalledocumento.push(Object.assign({}, val)));
    _detalledocumento.map(p => {
      if (cleanCheck)
        delete p.__typename
      delete p.additionalInfo
    })
    return _detalledocumento
  }

  BuscarItems() {
    this.onExecuteBuscar.emit(1);
  }

  validardorInput() {
    if (this.formHeader.get('rutProveedor').value === null) {
      this.toastService.warning('Debe ingresar rut de proveedor');
      return false;
    }
    if (this.formHeader.get('nFolio').value === null) {
      this.toastService.warning('Debe ingresar un numero de Folio');
      return false;
    }
  }
  OnChangeTotalxIva(iva) {
    this.MontoIva = parseInt(iva);

    if (iva === "") {
      this.MontoIva = 0;
    }

    if (!this.MontoAf) { this.MontoAf = 0; }
    if (!this.MontoEx) { this.MontoEx = 0; }

    this.TotalBruto = this.MontoIva + this.MontoAf + this.MontoEx + this.montoTotal
  }

  OnChangeTotalxAfecto(afecto) {
    this.MontoAf = parseInt(afecto);

    if (afecto === "") {
      this.MontoAf = 0;
    }

    if (!this.MontoIva) {
      this.MontoIva = 0;
    }
    if (!this.MontoEx) { this.MontoEx = 0; }

    this.fetchMontoIVA(this.MontoAf)
  }

  OnChangeTotalxExento(exento) {
    this.MontoEx = parseInt(exento);

    if (exento === "") {
      this.MontoEx = 0;
    }

    if (!this.MontoIva) { this.MontoIva = 0; }
    if (!this.MontoAf) { this.MontoAf = 0; }

    this.TotalBruto = this.MontoIva + this.MontoAf + this.MontoEx + this.montoTotal
  }

  private fetchMontoIVA(montoAfecto: number) {
    const inputParams = {
      entidad: {
        rut_receptor: this.rutEmpresa,
        monto_afecto: montoAfecto
      }
    }

    this.log('fetch monto IVA', JSON.stringify(inputParams))
    this.documentoRecepcionadoService.obtenerMontoImpuesto(inputParams, ({ respuesta }) => {
      const montoIVA = respuesta
      this.MontoIva = montoIVA
      this.TotalBruto = this.MontoIva + this.MontoAf + this.MontoEx + this.montoTotal

    })
  }

  // VALIDACION CAMPOS EN FALSO
  OnChangeFolio(folio) {

    if (folio == 0) {
      this.EnableButton = false;
    }

    if (folio == '') {
      this.EnableButton = false;
    }

    if (folio == null) {
      this.EnableButton = false;
    }

    this.Existefolio = folio
  }
}
